"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSurveyMarketsResponseToJSON = exports.GetSurveyMarketsResponseFromJSONTyped = exports.GetSurveyMarketsResponseFromJSON = exports.instanceOfGetSurveyMarketsResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the GetSurveyMarketsResponse interface.
 */
function instanceOfGetSurveyMarketsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetSurveyMarketsResponse = instanceOfGetSurveyMarketsResponse;
function GetSurveyMarketsResponseFromJSON(json) {
    return GetSurveyMarketsResponseFromJSONTyped(json, false);
}
exports.GetSurveyMarketsResponseFromJSON = GetSurveyMarketsResponseFromJSON;
function GetSurveyMarketsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'surveyMarkets': !(0, runtime_1.exists)(json, 'survey_markets') ? undefined : json['survey_markets'],
    };
}
exports.GetSurveyMarketsResponseFromJSONTyped = GetSurveyMarketsResponseFromJSONTyped;
function GetSurveyMarketsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'survey_markets': value.surveyMarkets,
    };
}
exports.GetSurveyMarketsResponseToJSON = GetSurveyMarketsResponseToJSON;
